import React, { FC } from 'react';
import { IFooter3 } from './params';
import Styles from './styles';
import convertToSlug from '../../../utils/convertToSlug';
import { footer, routing } from '../../../translates';

const Footer: FC<{ config: IFooter3; siteNameAlias: string; categories: string[]; language: string }> = ({
  config,
  siteNameAlias,
  categories,
  language,
}) => {
  const todaysYear = new Date();

  return (
    <Styles $config={config}>
      <div className="footer">
        <div className="container">
          <div className="footer-wrapper">
            <div className="footer-navlinks">
              <a href="/">{footer[language].home}</a>
              <a href={routing[language].articles + '/'}>{footer[language].articles}</a>
              <a href={routing[language].terms + '/'}>{footer[language].regulations}</a>
              <a href={routing[language].cookies + '/'}>{footer[language].cookiePolicy}</a>
              <a href={routing[language].contact + '/'}>{footer[language].contact}</a>
            </div>
            <div className="footer-siteName">{siteNameAlias}</div>
            {categories && categories.length > 0 ? (
              <ul className="footer-categories">
                {categories.map((category, index) => (
                  <li key={index} className="footer-categories-category">
                    <a key={category} href={`${routing[language].articles}/${convertToSlug(category)}/`}>
                      {category}
                    </a>
                  </li>
                ))}
              </ul>
            ) : null}
          </div>
          <div className="footer-copyright">
            <p>
              Copyright {todaysYear.getFullYear()} &nbsp;<span>{siteNameAlias}</span> - {footer[language].copyright}
            </p>
          </div>
        </div>
      </div>
    </Styles>
  );
};

export default Footer;
